import { useState } from "react";
import { getIcon } from "../../../../../../../utils/get-icon";
import { useSettings } from "../../../context";
import {
  BottomWrapper,
  CategoriesWrapper,
  CategoryButton,
  ClearButton,
  FieldWrapper,
  FontTitle,
  Input,
  LeftSelectCol,
  ListWrapper,
  NoResultsLabel,
  NoResultsWrapper,
  ResetButton,
  ResultLabel,
  ResultsWrapper,
  RightSelectCol,
  SearchIcon,
  SearchInputWrapper,
  SearchWrapper,
  SelectButton,
  SelectedFont,
  SelectedIcon,
  SelectedWrapper,
  SelectionButton,
  SelectionWrapper,
  TopWrapper,
} from "./styled";
import { popular_fonts } from "../../../../../../../library/font-picker/popular";

const FontSelectConfiguration = () => {
  const [searchText, setSearchText] = useState<string>("");
  const [isSearching, setIsSearching] = useState<boolean>(false);
  const [selectedTab, setSelectedTab] = useState<"popular" | "all">("popular");
  const { fonts, updateFontSettings, getSelectedItemSettings } = useSettings();

  const currentSettings = getSelectedItemSettings();

  const handleFontFamilyChange = (selected: any) => {
    const selectedFont = fonts?.find(
      (font: any) => font.family === selected.value
    );

    if (selectedFont) {
      updateFontSettings({ family: selectedFont.family });
    }
  };

  const handleChangeTab = (tab: "popular" | "all") => {
    setSelectedTab(tab);
  };

  const clickSelect = () => {
    setIsSearching(true);
  };

  const clickCollapse = () => {
    setIsSearching(false);
  };

  const getFilteredFonts = () => {
    // First determine which source of fonts to use based on the tab
    const sourceList =
      selectedTab === "popular"
        ? popular_fonts
        : fonts?.map((font: any) => ({
            value: font.family,
            title: font.family,
            url: font.files?.regular,
            variants: font.variants,
          })) || [];

    // Then apply the search filter if there is search text
    if (!searchText) return sourceList;

    return sourceList.filter((font: any) =>
      font.title.toLowerCase().includes(searchText.toLowerCase())
    );
  };

  const onSearch = (e: any) => {
    setSearchText(e.target.value);
  };

  const clearSearch = () => {
    setSearchText("");
  };

  const renderResults = () => {
    const filteredFonts = getFilteredFonts();

    if (filteredFonts.length === 0) {
      return (
        <NoResultsWrapper>
          <NoResultsLabel>Kunne ikke finne font.</NoResultsLabel>
        </NoResultsWrapper>
      );
    }

    return (
      <ListWrapper>
        {filteredFonts.map((font: any) => (
          <SelectionWrapper
            key={font.value}
            onClick={() => handleFontFamilyChange(font)}
          >
            <FontTitle>{font.title}</FontTitle>
            <SelectionButton
              className={
                currentSettings.configuration.font.family === font.family
                  ? "active"
                  : ""
              }
            >
              {currentSettings.configuration.font.family === font.family
                ? getIcon("selected-box")
                : getIcon("unselected-box")}
            </SelectionButton>
          </SelectionWrapper>
        ))}
      </ListWrapper>
    );
  };

  return (
    <>
      <FieldWrapper>
        {isSearching ? (
          <SearchWrapper>
            <TopWrapper>
              {searchText ? (
                <ResultsWrapper>
                  <ResultLabel>Søkeresultater</ResultLabel>
                </ResultsWrapper>
              ) : (
                <CategoriesWrapper>
                  <CategoryButton
                    onClick={() => handleChangeTab("popular")}
                    active={selectedTab === "popular"}
                  >
                    Populære
                  </CategoryButton>
                  <CategoryButton
                    onClick={() => handleChangeTab("all")}
                    active={selectedTab === "all"}
                  >
                    Alle
                  </CategoryButton>
                </CategoriesWrapper>
              )}
              <ResetButton onClick={clickCollapse}>
                {getIcon("arrow-down")}
              </ResetButton>
            </TopWrapper>
            {renderResults()}
            <BottomWrapper>
              <SearchInputWrapper>
                <SearchIcon>{getIcon("search")}</SearchIcon>
                <Input
                  value={searchText}
                  onChange={onSearch}
                  placeholder="Søk etter font"
                />
                {searchText && (
                  <ClearButton onClick={clearSearch}>
                    {getIcon("remove")}
                  </ClearButton>
                )}
              </SearchInputWrapper>
            </BottomWrapper>
          </SearchWrapper>
        ) : (
          <SelectedWrapper>
            <LeftSelectCol>
              <SelectedIcon>{getIcon("selected-font")}</SelectedIcon>
              <SelectedFont>
                {currentSettings.configuration.font.family}
              </SelectedFont>
            </LeftSelectCol>
            <RightSelectCol>
              <SelectButton onClick={clickSelect}>
                Velg font {getIcon("select-right")}
              </SelectButton>
            </RightSelectCol>
          </SelectedWrapper>
        )}
      </FieldWrapper>
    </>
  );
};

export default FontSelectConfiguration;

/*
<FontPicker
          fonts={fonts}
          selectedFont={currentSettings.configuration.font.family}
          onSelect={handleFontFamilyChange}
        />
*/
